var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteGoldBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89024 11.3341L6.78666 16.2658L0.303609 12.5246L1.80182 8.18281L6.89024 11.3341ZM18.8591 4.34136L7.3632 10.7864L2.08984 7.69695L2.06746 7.73366L2.02734 7.71053L13.6634 0.983097L19.2114 4.25453L19.2542 4.37719L19.1779 4.24195L18.8929 4.39983L18.8591 4.34136ZM19.3696 4.70841L20.6953 8.51277L7.31936 16.2354L7.74355 11.5407L15.1146 7.15229L19.3696 4.70841Z",
    fill: "#F7FEFF",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGoldBar);
export default __webpack_public_path__ + "static/media/WhiteGoldBar.7b590f9a58f356ca3930ec23b18442e0.svg";
export { ForwardRef as ReactComponent };